import { Spinner } from "@blueprintjs/core"
import CustomButton from "components/Atoms/CustomButton"
import NewResourceButton from "components/Organisms/AddResourceButton"
import NoResults from "components/Organisms/NoResults"
import { useSellableItemStockDetail } from "graphql/sellable-item/sellable-item.hooks"
import { cloneDeep, set } from "lodash-es"
import React, { useState } from "react"
import AppToaster from "utils/AppToaster"
import SellableItemStock from "./SellableItemStock"
const ItemStockList = ({ selectedItem, item }) => {
  const [stockList, setStocks] = useState([])
  const { loading, refetch } = useSellableItemStockDetail(
    /*
    Only query the server if this tab is the one which is active (prevents unnecessary api calls)
    */
    selectedItem?.id === item?.id ? item?.id : undefined,
    {
      onCompleted(data) {
        setStocks(data.sellableItemStock ?? [])
      },
    }
  )

  function handleDelete(_, index) {
    setStocks(prev => prev.filter((_, idx) => idx !== index))
  }
  const dcs = stockList?.map?.(s => s?.distributionCentre)
  if (loading) {
    return <Spinner />
  }
  if (stockList?.length === 0)
    return (
      <NoResults
        icon="search"
        title="No Stocks found for the given sellable item, please add one"
        action={
          <CustomButton
            icon="plus"
            intent="success"
            text="Stock"
            onClick={handleStockAdd}
          />
        }
      />
    )

  function handleStockAdd(e) {
    if (stockList?.length >= 1) {
      AppToaster.show({
        message: `A stock for ${item?.name} on dc already exists, please ensure that the visible groups are different`,
        intent: "warning",
        icon: "warning-sign",
      })
    }
    setStocks(prev => (prev ? [{}].concat(prev) : [{}]))
  }

  return (
    <section>
      <div className="grid grid-cols-12 mb-2 gap-4">
        <div className="ml-auto col-span-3 col-end-13 w-full ">
          <NewResourceButton
            module="stock"
            to="/d/ecom/stock/sellable-items"
            intent="success"
            icon="plus"
            text="Stock"
            fill
            big
            onClick={handleStockAdd}
          />
          {/* <CustomButton onClick={handleStockAdd} /> */}
        </div>
      </div>
      {stockList?.map((s, idx) => {
        return (
          <SellableItemStock
            onCompleted={(idx, item) => {
              const stocksCopy = cloneDeep(stockList)
              set(stocksCopy, idx, item)
              setStocks(stocksCopy)
            }}
            sellableItem={item}
            index={idx}
            onDelete={handleDelete}
            key={s.id ?? `item-${idx}`}
            stock={s ?? {}}
            dcs={dcs}
            refetch={refetch}
          />
        )
      })}
    </section>
  )
}

export default ItemStockList
